import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import AppSection from './components/AppSection';
import Faq from './components/Faq';
import Ranking from './components/Ranking';
import About from './components/About';
import Contact from './components/Contact';
import Media from './components/Media';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import Index from './components/Index';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleHashClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      e.preventDefault();
      const id = href.slice(1);
      const el = document.getElementById(id);
      if (el) {
        const headerHeight = 72;
        const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    document.addEventListener('click', handleHashClick);
    return () => document.removeEventListener('click', handleHashClick);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <AppSection />
        <Faq />
        <Ranking />
        <About />
        <Contact />
        <Media />
        <Updates />
        <Topics />
        <Carousel />
        <Cards />
        <Index />
        <Comments />
      </main>
      <Footer />
    </>
  );
}